import { render, staticRenderFns } from "./pay-set.vue?vue&type=template&id=a8161872"
import script from "./pay-set.vue?vue&type=script&lang=js"
export * from "./pay-set.vue?vue&type=script&lang=js"
import style0 from "./pay-set.vue?vue&type=style&index=0&id=a8161872&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports